import { render } from "./study-system.vue?vue&type=template&id=588505f8&scoped=true"
import script from "./study-system.vue?vue&type=script&lang=js"
export * from "./study-system.vue?vue&type=script&lang=js"

import "./study-system.vue?vue&type=style&index=0&id=588505f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588505f8"]])

export default __exports__